export default {
  "about": "关于",
  "about_title": "关于我们",
  "access_secret": "访问密钥",
  "access_token": "访问令牌",
  "accessibility_animations": "动画",
  "accessibility_contrast": "对比度",
  "accessibility_font_size": "字体大小",
  "accessibility_title": "无障碍功能",
  "actions": "操作",
  "active": "活跃",
  "active_ads": "活跃广告",
  "active_campaigns": "活跃活动",
  "ad_code_placeholder": "<script>...</script> 或 AdSense 插槽代码",
  "ad_format": "广告格式",
  "ad_formats": "广告格式",
  "ad_management": "广告管理",
  "ad_position_settings": "广告位置设置",
  "ad_price_list": "广告价目表",
  "ad_pricing_formats_campaigns": "定价、格式、活动和追踪",
  "add": "添加",
  "add_api_keys": "在设置选项卡中添加 API 密钥",
  "address": "地址",
  "admin": "管理",
  "adminPanel": "管理面板",
  "admin_ab_testing_title": "A/B 测试",
  "admin_accent": "强调色",
  "admin_accent_color": "强调色",
  "admin_action": "操作",
  "admin_activate": "激活",
  "admin_active_feeds": "活跃订阅",
  "admin_active_label": "活动",
  "admin_active_now": "当前活跃",
  "admin_active_subscribers": "活跃订阅者",
  "admin_ad_performance": "广告表现",
  "admin_add_feed": "添加订阅",
  "admin_add_tag": "添加标签",
  "admin_admins": "管理员",
  "admin_advertisements": "广告",
  "admin_advertiser_email": "广告商邮箱",
  "admin_advertiser_name": "广告商名称",
  "admin_affiliate_links": "联盟链接",
  "admin_ai_content_title": "AI 内容处理",
  "admin_ai_prompt_settings": "AI 提示与模型设置",
  "admin_analytics_title": "分析",
  "admin_api_latency": "API 延迟",
  "admin_api_server": "API 服务器",
  "admin_article_actions": "操作",
  "admin_article_category": "类别",
  "admin_article_published": "已发布",
  "admin_article_selector": "文章选择器（CSS，例如 article.news）",
  "admin_article_views": "查看次数",
  "admin_articles_count": "文章",
  "admin_articles_title": "文章",
  "admin_author_change_failed": "更改作者失败。",
  "admin_authors_title": "作者",
  "admin_auto": "自动",
  "admin_auto_save_draft": "自动保存为草稿",
  "admin_avg_seo_score": "平均 SEO 分数",
  "admin_bio": "简介",
  "admin_blog_manage": "使用富文本编辑器管理博客文章",
  "admin_blog_title": "博客",
  "admin_brand_theme": "品牌和主题",
  "admin_branding_desc": "自定义网站外观（仅限系统管理员）",
  "admin_branding_title": "重新品牌化模块",
  "admin_breaking_ticker": "突发新闻滚动",
  "admin_browser": "浏览器",
  "admin_browsers": "浏览器",
  "admin_bug_reports": "错误报告",
  "admin_bulk_delete_failed": "批量删除失败。",
  "admin_bulk_operations": "批量操作",
  "admin_categories_grid": "类别网格",
  "admin_choose_gallery": "从图库中选择",
  "admin_churn_prediction": "流失预测",
  "admin_classic_portal": "经典新闻门户",
  "admin_classifieds": "分类广告",
  "admin_clear_log": "清除日志",
  "admin_click_button": "点击按钮",
  "admin_collection_stats": "收藏统计",
  "admin_color_scheme": "配色方案",
  "admin_columnist": "专栏作家",
  "admin_comments": "评论",
  "admin_competitor_monitoring": "竞争对手监控",
  "admin_confirm_action": "你确定吗？",
  "admin_content_calendar_title": "内容日历",
  "admin_content_filter": "内容过滤条件",
  "admin_content_stats": "内容统计",
  "admin_contributor": "贡献者",
  "admin_coordinates": "坐标",
  "admin_copy_ip": "复制IP地址",
  "admin_copy_text": "复制",
  "admin_core_services": "核心服务",
  "admin_countries": "国家",
  "admin_cpc": "每次点击费用 (EUR)",
  "admin_crawl_now": "立即爬取",
  "admin_create_author": "创建作者",
  "admin_create_manage_promo": "创建和管理促销代码",
  "admin_create_voucher": "创建凭证",
  "admin_custom_meta": "自定义 Meta",
  "admin_dashboard_title": "仪表板",
  "admin_database": "数据库",
  "admin_db_backup": "数据库备份",
  "admin_db_latency": "数据库延迟",
  "admin_db_name": "数据库名称",
  "admin_db_size": "数据库大小",
  "admin_default": "默认",
  "admin_default_language": "默认语言",
  "admin_device": "设备",
  "admin_devices": "设备",
  "admin_discount": "折扣",
  "admin_disk_usage": "磁盘使用",
  "admin_docs_api_ref": "API参考",
  "admin_docs_download_pdf": "下载PDF",
  "admin_docs_faq": "常见问题",
  "admin_docs_getting_started": "入门指南",
  "admin_docs_implemented": "已实施",
  "admin_docs_no_pages": "尚无文档页面",
  "admin_docs_order": "顺序",
  "admin_docs_title": "文档",
  "admin_doktor_earnings": "Doktor 收益",
  "admin_draft_articles": "草稿文章",
  "admin_dynamic_pricing": "动态定价",
  "admin_edit_in_cms": "在CMS中编辑",
  "admin_editor_role": "编辑",
  "admin_export_csv": "导出 CSV",
  "admin_favicon": "网站图标",
  "admin_feed_crawler": "订阅抓取器",
  "admin_feed_name": "订阅名称",
  "admin_feed_url": "订阅 URL",
  "admin_feeds_title": "RSS 订阅",
  "admin_file": "文件",
  "admin_fixed_amount": "固定金额",
  "admin_frozen": "冻结",
  "admin_full_name": "全名",
  "admin_general": "常规",
  "admin_google_search_console": "Google 搜索控制台",
  "admin_grade": "评分",
  "admin_health_title": "健康检查",
  "admin_high_leads": "高价值线索",
  "admin_import_title": "Croatia Times导入平台",
  "admin_index_now": "立即索引",
  "admin_integrations": "集成",
  "admin_job_postings": "职位发布",
  "admin_joined": "已加入",
  "admin_keywords": "关键词",
  "admin_landing_title": "登陆页面",
  "admin_last_submissions": "最后提交",
  "admin_live_analytics": "实时分析",
  "admin_live_analytics_title": "实时分析",
  "admin_llm_model": "LLM模型",
  "admin_manage_feeds": "管理订阅",
  "admin_mass_management": "批量文章管理",
  "admin_max_articles": "最大文章数",
  "admin_media_storage": "媒体存储",
  "admin_memory": "内存",
  "admin_menu_manager": "菜单管理",
  "admin_meta_description": "Meta描述",
  "admin_monetization_title": "货币化仪表盘",
  "admin_mysql_db": "MySQL数据库",
  "admin_mysql_host": "MySQL主机",
  "admin_nav_ab_testing": "A/B测试",
  "admin_nav_ads": "广告管理",
  "admin_nav_ads_report": "广告报告",
  "admin_nav_adsense": "AdSense 设置",
  "admin_nav_advanced_analytics": "高级分析",
  "admin_nav_affiliates": "联盟链接",
  "admin_nav_ai_content": "AI内容处理",
  "admin_nav_amp": "AMP & Google Discover",
  "admin_nav_analytics": "分析",
  "admin_nav_analytics_ai": "分析和AI",
  "admin_nav_articles": "文章",
  "admin_nav_audit_log": "审计日志",
  "admin_nav_authors": "作者",
  "admin_nav_blog": "博客",
  "admin_nav_branding": "品牌重塑",
  "admin_nav_breaking_news": "突发/快讯",
  "admin_nav_bulk_operations": "批量操作",
  "admin_nav_categories": "类别",
  "admin_nav_chat_sessions": "聊天会话",
  "admin_nav_churn_prediction": "客户流失预测",
  "admin_nav_classifieds": "分类广告",
  "admin_nav_comments": "评论",
  "admin_nav_competitor_monitoring": "竞争对手监控",
  "admin_nav_content": "内容",
  "admin_nav_content_calendar": "内容日历",
  "admin_nav_county_map": "县地图",
  "admin_nav_crypto": "加密小部件",
  "admin_nav_dashboard": "仪表盘",
  "admin_nav_db_backup": "数据库",
  "admin_nav_docs": "文档",
  "admin_nav_doktor_earnings": "Doktor 收益",
  "admin_nav_duplicate_detection": "重复检测",
  "admin_nav_editorial": "编辑",
  "admin_nav_editorial_workflow": "编辑工作流程",
  "admin_nav_email_campaigns": "电子邮件活动",
  "admin_nav_feeds": "RSS订阅",
  "admin_nav_finance": "金融",
  "admin_nav_health": "系统健康",
  "admin_nav_heatmaps": "阅读热图",
  "admin_nav_import": "导入",
  "admin_nav_invoices": "发票",
  "admin_nav_job_ads": "招聘广告",
  "admin_nav_landing_pages": "登录页面",
  "admin_nav_live_analytics": "实时分析",
  "admin_nav_management": "管理",
  "admin_nav_marketing": "营销",
  "admin_nav_media": "媒体",
  "admin_nav_menu_manager": "菜单管理",
  "admin_nav_micropayments": "小额支付",
  "admin_nav_monetization": "货币化",
  "admin_nav_newsletter": "简讯",
  "admin_nav_newsletter_digest": "简讯摘要",
  "admin_nav_pages": "页面",
  "admin_nav_payments": "支付",
  "admin_nav_performance_forecast": "性能预测",
  "admin_nav_photo_verification": "照片验证",
  "admin_nav_portal_toggle": "门户管理",
  "admin_nav_portals": "门户",
  "admin_nav_pricing": "定价",
  "admin_nav_promo_codes": "促销代码",
  "admin_nav_push_notifications": "推送通知",
  "admin_nav_quizzes": "测验",
  "admin_nav_recommendations": "内容推荐",
  "admin_nav_reports": "内容报告",
  "admin_nav_sanitization": "内容净化",
  "admin_nav_scheduler": "内容调度器",
  "admin_nav_security": "安全性",
  "admin_nav_seo_dashboard": "SEO 仪表板",
  "admin_nav_seo_distribution": "SEO & 分发",
  "admin_nav_series": "文章系列",
  "admin_nav_settings": "设置",
  "admin_nav_social": "社交媒体",
  "admin_nav_social_scheduler": "社交日程表",
  "admin_nav_sponsored": "赞助",
  "admin_nav_sponsored_marketplace": "赞助市场",
  "admin_nav_subscriptions": "订阅",
  "admin_nav_surveys": "调查",
  "admin_nav_syndication": "联合 API",
  "admin_nav_system": "系统",
  "admin_nav_tips": "小费/捐赠",
  "admin_nav_translations": "翻译",
  "admin_nav_ugc_review": "公民内容",
  "admin_nav_users": "用户",
  "admin_nav_users_subscriptions": "用户和订阅",
  "admin_nav_versioning": "版本历史",
  "admin_nav_vibeposao": "Times Posao门户",
  "admin_nav_vouchers": "代金券/折扣",
  "admin_nav_widgets": "小部件 / 目录",
  "admin_new_author_name": "新作者名...",
  "admin_new_post": "新帖子",
  "admin_no_data": "没有可用数据",
  "admin_no_icon": "无图标",
  "admin_no_logo": "无标志",
  "admin_no_pending_reports": "没有待定报告",
  "admin_no_published_articles": "未找到已发布文章",
  "admin_password_field": "密码",
  "admin_performance_forecast": "性能预测",
  "admin_photo_verification": "照片验证",
  "admin_plan": "计划",
  "admin_platform_audit": "平台审计",
  "admin_portal_toggle": "门户管理",
  "admin_premium_users": "高级用户",
  "admin_primary": "主要",
  "admin_published_articles": "已发布文章",
  "admin_published_today": "今日发布",
  "admin_quick_actions": "快捷操作",
  "admin_recent_articles": "最新文章",
  "admin_role_change_failed": "更新角色失败。",
  "admin_search_placeholder": "搜索管理员...",
  "admin_secondary": "次要",
  "admin_seo_desc": "内容优化、GSC 和 sitemap 管理",
  "admin_seo_title": "SEO 仪表盘",
  "admin_service_requests": "服务请求",
  "admin_set_category": "设置类别",
  "admin_set_featured": "设置为精选",
  "admin_settings_saved": "设置已保存",
  "admin_settings_title": "设置",
  "admin_short_desc": "简短描述",
  "admin_site_identity": "网站标识",
  "admin_site_logo": "网站标志",
  "admin_site_settings": "网站设置",
  "admin_sponsored_marketplace": "赞助市场",
  "admin_sponsored_title": "赞助文章",
  "admin_surveys_title": "调查",
  "admin_system_status": "系统状态",
  "admin_table_header_actions": "操作",
  "admin_table_header_date": "日期",
  "admin_table_header_email": "电子邮件",
  "admin_table_header_name": "名称",
  "admin_table_header_status": "状态",
  "admin_thumbnail_settings_saved": "缩略图设置已保存",
  "admin_top_articles_views": "热门文章按浏览量",
  "admin_total_articles": "文章总数",
  "admin_total_users": "用户总数",
  "admin_total_views": "浏览总数",
  "admin_ugc_review": "UGC审核",
  "admin_username": "用户名",
  "admin_users_title": "用户",
  "admin_version_history": "版本历史",
  "admin_view_health_report": "查看完整健康报告",
  "admin_write_new_article": "撰写新文章",
  "adsense_client_id": "AdSense客户ID",
  "adsense_enable_disable": "启用/禁用所有自动广告投放",
  "adsense_global_toggle": "AdSense全局切换",
  "adsense_script_code": "AdSense脚本代码",
  "adsense_settings": "AdSense及广告位置",
  "advertise_contact_sales": "联系销售",
  "advertise_get_started": "开始使用",
  "advertise_reach_audience": "触达我们的受众",
  "advertise_title": "与我们合作广告",
  "advertiser": "广告商",
  "advertiser_analytics": "广告商分析",
  "advertiser_email": "广告商电子邮件",
  "advertising": "广告",
  "advertising_cookies": "广告 Cookie",
  "affiliate_title": "联盟计划",
  "ago": "前",
  "ai_image_prompt": "AI 图片提示",
  "all": "所有",
  "all_categories": "所有类别",
  "all_jobs": "全部职位",
  "all_rights": "版权所有",
  "all_status": "所有状态",
  "all_types": "所有类型",
  "alpha": "α版",
  "alreadyHaveAccount": "已经有账户？",
  "already_have_account": "已有账户?",
  "analytics": "分析",
  "analytics_cookies": "分析 Cookie",
  "api_key": "API 密钥",
  "api_secret": "API 密钥",
  "applications": "申请",
  "apply": "申请",
  "apply_now": "立即申请",
  "approve": "批准",
  "approved": "已批准",
  "archive": "存档",
  "archived": "已归档",
  "article_content": "文章内容",
  "article_title": "文章标题...",
  "article_views": "查看次数",
  "author": "作者",
  "auto_posting": "自动发布和社交整合",
  "auto_share_articles": "自动在连接的平台上分享已发布的文章",
  "avg_ctr": "平均CTR",
  "back": "返回",
  "basic": "基本",
  "be_respectful": "尊重他人，与其他用户和文章主题和谐相处",
  "beta": "测试版",
  "book_ad": "预订广告",
  "booking_details": "预订详情",
  "breaking": "突发新闻",
  "bug_description": "错误描述",
  "business": "商业",
  "business_account_id": "业务账户 ID",
  "buyer": "买家",
  "campaign_details": "活动详情",
  "campaigns": "活动",
  "cancel": "取消",
  "caption": "标题",
  "categories": "分类",
  "category": "类别",
  "category_distribution": "类别分布",
  "category_push_subscribers": "类别推送订阅者",
  "chatbot_placeholder": "输入消息...",
  "chatbot_send": "发送",
  "chatbot_title": "聊天助手",
  "choose_plan": "选择方案",
  "city": "城市",
  "classifieds": "分类广告",
  "classifieds_title": "分类信息",
  "clear": "清除",
  "click_rate": "点击率",
  "click_url": "点击网址（目标）",
  "clicks": "点击",
  "client_id": "客户端 ID",
  "client_secret": "客户端密钥",
  "close": "关闭",
  "code": "代码",
  "commenting_rules": "评论规则",
  "comments": "评论",
  "companies": "公司",
  "company": "公司",
  "compose_social_post": "撰写社交帖子",
  "configure": "配置",
  "configure_position": "使用自定义横幅图像或广告代码配置每个位置",
  "confirm": "确认",
  "confirm_delete": "确定要删除吗？",
  "confirm_password": "确认密码",
  "congratulations": "祝贺你",
  "contact": "联系我们",
  "contact_title": "联系",
  "contact_us": "联系我们",
  "content": "内容",
  "cookies": "Cookies",
  "cookies_title": "Cookie 政策",
  "copy": "复制",
  "copyright": "版权",
  "copyright_notice": "版权声明",
  "count": "统计",
  "country": "国家",
  "cpm": "CPM",
  "create": "创建",
  "create_first_ad": "创建您的第一个广告",
  "crypto_change_24h": "24小时变动",
  "crypto_market_cap": "市值",
  "crypto_price": "价格",
  "crypto_widget_title": "加密货币",
  "ctr": "CTR",
  "culture": "文化",
  "current_plan": "当前方案",
  "custom_ad_code": "自定义广告代码",
  "custom_banner_url": "自定义横幅网址",
  "custom_range": "自定义范围",
  "daily_budget": "每日预算",
  "daily_performance": "每日表现",
  "dark_mode": "深色模式",
  "data_viz_title": "数据可视化",
  "date": "日期",
  "dating_add_video": "添加一个短视频，以便潜在匹配者更好地了解你",
  "dating_block": "阻止",
  "dating_boosts": "提升",
  "dating_city": "城市",
  "dating_next": "下一个",
  "dating_personality_quiz": "性格测验",
  "dating_quiz_completed": "性格测验已完成",
  "dating_users": "用户",
  "dating_verify_identity": "验证您是一个真实的人",
  "dating_voice_message": "语音消息",
  "days": "天",
  "delete": "删除",
  "delete_failed": "删除失败。",
  "deleted_successfully": "删除成功",
  "deprecated": "已弃用",
  "describe_thumbnail": "描述缩略图以生成...",
  "description": "描述",
  "deselect_all": "取消全选",
  "desktop": "桌面",
  "details": "详细信息",
  "dimensions": "尺寸",
  "disabled": "已禁用",
  "dismiss": "解除",
  "documentation": "文档",
  "doktor_add_document": "添加文档",
  "doktor_biography": "个人简介",
  "doktor_birth_date": "出生日期",
  "doktor_chat": "聊天",
  "doktor_control_date": "控制日期",
  "doktor_date": "日期",
  "doktor_diagnosis": "诊断",
  "doktor_enter_name_specialization": "输入姓名和至少一个专长",
  "doktor_enter_patient_name": "输入病人姓名",
  "doktor_license_number": "执照号码",
  "doktor_panel": "医生面板",
  "doktor_patient_name": "病人姓名",
  "doktor_text_min_chars": "文本必须至少有50个字符",
  "doktor_waiting_room": "候诊室",
  "dont_have_account": "没有账户?",
  "download": "下载",
  "draft": "草稿",
  "duplicate": "重复",
  "duration_days": "持续时间（天）",
  "economy": "经济",
  "edit": "编辑",
  "electronics": "电子产品",
  "email": "电子邮件",
  "email_address": "电子邮箱地址",
  "email_campaigns": "电子邮件活动",
  "email_clicks": "邮件点击",
  "email_content": "电子邮件内容...",
  "email_opens": "邮件打开",
  "email_placeholder": "您的邮箱",
  "email_subject": "电子邮件主题",
  "employer": "雇主",
  "enabled": "已启用",
  "end_date": "结束日期",
  "enter_advertiser_email": "输入您的广告商电子邮件...",
  "enter_email_to_view": "在上方输入您的广告商电子邮件以查看您的活动表现",
  "entertainment": "娱乐",
  "error": "错误",
  "error_deleting": "删除错误",
  "error_generating_digest": "生成摘要错误",
  "error_loading": "加载错误",
  "error_saving": "保存错误",
  "error_saving_settings": "保存错误",
  "error_sending": "发送错误",
  "error_uploading": "上传错误",
  "error_uploading_photo": "上传照片失败",
  "events_calendar": "活动日历",
  "excerpt_summary": "摘录 / 摘要",
  "experimental": "实验性的",
  "export": "导出",
  "export_data": "导出数据",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Facebook登录不可用",
  "failed_post_comment": "发表评论失败。",
  "feature_flags": "功能标志",
  "feature_job": "特色职位",
  "featured": "精选",
  "featured_article": "特色文章",
  "featured_duration": "特色时长",
  "featured_image": "特色图片",
  "featured_jobs": "精选职位",
  "feedback": "反馈",
  "filter": "筛选",
  "filter_terms_saved": "过滤条件已保存！",
  "find_jobs": "找工作",
  "first": "第一页",
  "first_process_publish": "首先处理并发布文章",
  "footer_ai": "本门户使用AI辅助",
  "footer_ai_notice": "部分内容由AI辅助创建 - 报告问题",
  "footer_cat_business": "商业",
  "footer_cat_culture": "文化",
  "footer_cat_health": "健康",
  "footer_cat_news": "新闻",
  "footer_cat_politics": "政治",
  "footer_cat_sports": "体育",
  "footer_cat_technology": "技术",
  "footer_categories": "分类",
  "footer_copyright": "2026 Liber Nostra d.o.o. 保留所有权利。",
  "footer_description": "Croatia Times 是您信赖的新闻来源，提供来自克罗地亚及其他地区的突发新闻、深度分析和引人入胜的故事。",
  "footer_developed_by": "由...开发和维护，满怀热情",
  "footer_email_placeholder": "您的邮箱地址",
  "footer_here": "这里",
  "footer_hosted_by": "托管方",
  "footer_link_about": "关于我们",
  "footer_link_advertise": "广告",
  "footer_link_contact": "联系",
  "footer_link_cookies": "Cookies",
  "footer_link_imprint": "出版说明",
  "footer_link_privacy": "隐私政策",
  "footer_link_submit_news": "提交新闻",
  "footer_newsletter_text": "订阅我们的新闻通讯",
  "footer_quick_links": "快速链接",
  "footer_stay_informed": "保持知情",
  "footer_subscribe": "订阅",
  "for_you_personalized": "基于您的兴趣个性化内容",
  "for_you_title": "为你推荐",
  "forgot_password": "忘记密码?",
  "free": "免费",
  "free_plan": "免费",
  "from": "从",
  "full_time": "全职",
  "general": "常规",
  "goodbye": "再见",
  "hashtags": "标签",
  "hashtags_placeholder": "#news #croatia...",
  "header_auto_schedule_active": "自动计划启动",
  "header_forecast": "天气预报",
  "header_humidity": "湿度",
  "header_live": "直播",
  "header_portals_label": "门户",
  "header_weather_humidity": "湿度",
  "header_weather_wind": "风",
  "header_wind": "风",
  "health": "健康",
  "hello": "你好",
  "help": "帮助",
  "home": "首页",
  "home_podcast_title": "每周科技综述：克罗地亚初创企业中的人工智能",
  "home_video_title": "走进萨格勒布：街头艺术纪录片",
  "hours": "小时",
  "import": "导入",
  "impressions": "展示",
  "imprint": "版权声明",
  "imprint_title": "公司信息",
  "inactive": "不活跃",
  "info": "信息",
  "instagram": "Instagram",
  "invalid_code": "无效的代码。请再试一次。",
  "items_selected": "项已选",
  "job_categories": "职位类别",
  "job_postings": "职位发布",
  "job_seeker": "求职者",
  "jobs": "招聘",
  "just_now": "刚刚",
  "language": "语言",
  "last": "最后一页",
  "latest_news": "最新新闻",
  "legal": "法律",
  "lifestyle": "生活",
  "lifetime": "终身",
  "light_mode": "浅色模式",
  "linked_email_campaign": "链接到电子邮件活动",
  "linkedin": "LinkedIn",
  "live_stream": "直播",
  "load_more": "加载更多",
  "loading": "加载中...",
  "local": "本地",
  "location": "地点",
  "login": "登录",
  "logout": "退出",
  "loyalty_available_points": "可用积分",
  "loyalty_available_rewards": "可用奖励",
  "loyalty_badges": "徽章",
  "loyalty_consecutive_days": "连续天数",
  "loyalty_error": "错误",
  "loyalty_leaderboard": "排行榜",
  "loyalty_leaderboard_empty": "排行榜为空",
  "loyalty_rewards": "奖励",
  "loyalty_used_rewards": "已用奖励",
  "majstor_categories": "类别",
  "majstor_city": "城市",
  "majstor_company_name": "公司名称 *",
  "majstor_flexible": "灵活",
  "majstor_max_budget": "最高预算 (EUR)",
  "majstor_min_budget": "最低预算 (EUR)",
  "majstor_my_requests": "我的请求",
  "majstor_request_title": "请求标题 *",
  "majstor_service_categories": "服务类别",
  "majstor_urgent": "紧急",
  "manage": "管理",
  "manage_bookings": "管理广告商预订",
  "mark_as_read": "标记为已读",
  "marketing_dashboard": "营销仪表板",
  "marketing_live_metrics": "Croatia Times 的实时性能指标",
  "marketing_published_articles": "已发布文章",
  "marketing_registered_users": "注册用户",
  "marketing_today_views": "今日浏览量",
  "marketing_total_views": "总页面浏览量",
  "minutes": "分钟",
  "missing_translations": "缺失翻译",
  "mobile": "移动设备",
  "more": "更多",
  "most_popular": "最受欢迎",
  "most_read": "阅读最多",
  "move": "移动",
  "must_be_logged_in_purchase": "您必须登录才能购买文章",
  "myProfile": "我的资料",
  "my_applications": "我的申请",
  "name": "姓名",
  "new": "新",
  "new_article": "新文章",
  "new_campaign": "新活动",
  "new_notification": "新通知",
  "new_push_notification": "新推送通知",
  "new_verification_sent": "新的验证码已发送到您的电子邮件。",
  "news": "新闻",
  "newsletter": "订阅",
  "newsletter_desc": "订阅获取最新新闻",
  "newsletter_only_subscribers": "仅限订阅者",
  "newsletter_subscribers": "新闻订阅者",
  "next": "下一步",
  "no": "否",
  "noAccount": "没有账户？",
  "no_articles": "未找到文章",
  "no_bookings": "未找到预订",
  "no_campaigns": "没有活动",
  "no_data": "无可用数据",
  "no_items": "未找到项目",
  "no_linked_campaign": "无链接活动",
  "no_notifications": "无通知",
  "no_results": "无结果",
  "no_scheduled_posts": "尚无计划帖子",
  "no_sent_notifications": "无已发送通知",
  "none": "无",
  "note": "注意",
  "notification_body": "通知正文",
  "notification_title": "通知标题",
  "notifications": "通知",
  "of": "的",
  "off": "关闭",
  "offline": "离线",
  "on": "开启",
  "one_time": "一次性",
  "online": "在线",
  "open_rate": "打开率",
  "optional": "可选的",
  "options": "选项",
  "orContinueWith": "或者继续使用",
  "or_continue_with": "或使用以下方式",
  "order": "订单",
  "other": "其他",
  "page": "页面",
  "part_time": "兼职",
  "password": "密码",
  "paste": "粘贴",
  "pause": "暂停",
  "payment_error": "支付错误",
  "payment_processing": "正在处理付款...",
  "payment_success": "支付成功!",
  "payment_thank_you": "感谢您的购买！",
  "pending": "待定",
  "pending_approval": "等待批准",
  "per_month": "/月",
  "per_page": "每页",
  "percentage": "百分比",
  "performance": "表现",
  "phone": "电话",
  "platforms": "平台",
  "politics": "政治",
  "poll_results": "结果",
  "poll_total_votes": "总投票数",
  "poll_vote": "投票",
  "popular": "热门",
  "post_comment": "发表评论",
  "post_error": "发布错误",
  "post_job": "发布职位",
  "post_now": "立即发布",
  "powered_by": "技术支持",
  "premium": "高级",
  "preview": "预览",
  "previous": "上一步",
  "price": "价格",
  "privacy": "隐私",
  "privacy_title": "隐私政策",
  "proceed_to_payment": "继续支付",
  "profile": "个人资料",
  "profile_admin_access": "管理员快速访问",
  "profile_analytics": "分析",
  "profile_articles": "文章",
  "profile_dashboard": "仪表板",
  "profile_edit": "编辑个人资料",
  "profile_verified": "资料已验证！",
  "promo_success": "促销代码已成功应用！",
  "promote_job": "推广职位",
  "publish": "发布",
  "published": "发布于",
  "published_date": "发布日期",
  "push_notifications": "推送通知",
  "read": "已读",
  "read_more": "阅读更多",
  "real_estate": "房地产",
  "recent": "最新",
  "recipes_add_first": "添加你的第一个食谱",
  "recipes_browse_all": "浏览所有食谱",
  "recipes_category": "类别",
  "recipes_cook_time": "烹饪时间",
  "recipes_easy": "简单",
  "recipes_featured": "特色食谱",
  "recipes_filters": "过滤器",
  "recipes_ingredient": "成分",
  "recipes_ingredients": "配料",
  "recipes_instructions": "说明",
  "recipes_latest": "最新食谱",
  "recipes_most_popular": "最受欢迎的食谱",
  "recipes_prep_time": "准备时间",
  "recipes_search": "搜索食谱...",
  "recipes_servings": "供应",
  "recipes_title": "食谱",
  "recommended": "推荐的",
  "refresh": "刷新",
  "region": "地区",
  "register": "注册",
  "reject": "拒绝",
  "rejected": "已拒绝",
  "related_articles": "相关文章",
  "remote": "远程",
  "remove": "移除",
  "report": "报告",
  "reports": "报告",
  "reposting_rules_title": "转发规则",
  "required": "必需的",
  "reset": "重置",
  "restore": "恢复",
  "results": "结果",
  "resume": "继续",
  "revision_restored": "修订版本已恢复！",
  "salary": "薪资",
  "salary_max": "最高工资",
  "salary_min": "最低工资",
  "save": "保存",
  "saved_jobs": "已保存职位",
  "saved_successfully": "保存成功",
  "schedule": "日程",
  "scheduled": "已安排",
  "science": "科学",
  "search": "搜索...",
  "search_articles": "搜索文章...",
  "search_placeholder": "搜索...",
  "search_results_for": "搜索结果",
  "seconds": "秒",
  "see_all": "查看全部",
  "select": "选择",
  "select_all": "全选",
  "select_format": "选择格式",
  "seller": "卖家",
  "send_campaign": "发送活动",
  "sent": "已发送",
  "sent_campaigns": "已发送的活动",
  "services": "服务",
  "settings": "设置",
  "share": "分享",
  "showing": "显示",
  "signIn": "登录",
  "signOut": "退出登录",
  "site_name": "Croatia Times",
  "site_subtitle": "今日克罗地亚",
  "six_digit_code": "6位数字代码",
  "social_media": "社交媒体",
  "social_scheduler": "社交计划器",
  "sort": "排序",
  "sponsored_marketplace_title": "赞助市场",
  "sports": "体育",
  "stable": "稳定版",
  "start": "开始",
  "start_date": "开始日期",
  "static_about_contact": "有关编辑咨询、广告或一般信息，请访问我们的",
  "static_about_contact_page": "联系页面",
  "static_about_contact_title": "联系方式",
  "static_about_lead": "Croatia Times 是一个独立的新闻门户，向您提供来自克罗地亚和该地区的最新新闻、分析、评论和故事。我们是 e-mina.eu 媒体家族的一部分，拥有相同的团队和价值观。",
  "static_about_mission": "我们致力于提供准确、及时和优质的新闻报道，以服务公众利益。我们的编辑团队由经验丰富的记者组成，他们对克罗地亚和区域事务有深入的了解。",
  "static_about_mission_title": "我们的使命",
  "static_about_publisher": "Liber Nostra d.o.o. 是 Croatia Times 和 e-mina.eu 的出版商。这家公司专注于数字媒体和以克罗地亚市场为中心的新闻门户。",
  "static_about_publisher_title": "出版者",
  "static_about_standards": "Croatia Times 遵循最高的新闻标准。我们对报道进行事实核查，明确标记评论和分析，并迅速透明地纠正错误。",
  "static_about_standards_title": "编辑标准",
  "static_about_team": "Croatia Times 背后是一个由经验丰富的媒体专业人士、记者、编辑和技术专家组成的团队，他们致力于平台开发和内容质量。我们团队也是成功的门户 e-mina.eu - 国际新闻社 的幕后团队。",
  "static_about_team_title": "团队",
  "static_about_title": "关于我们 - Croatia Times",
  "static_bug_description": "错误描述",
  "static_bug_description_placeholder": "描述发生了什么以及如何重现该问题...",
  "static_bug_intro": "发现不能正常工作的东西？告诉我们，我们会及时修复。",
  "static_bug_page_url": "页面URL（错误发生的位置）",
  "static_bug_screenshot": "截图（可选）",
  "static_bug_submit": "提交错误报告",
  "static_bug_submitting": "正在提交...",
  "static_bug_thanks": "感谢您的报告！我们会调查并修复该问题。",
  "static_bug_title": "报告错误",
  "static_commenting_intro": "我们欢迎建设性的讨论。为保持我们的评论区积极和富有成效，请遵循以下规则：",
  "static_commenting_login": "要发表评论，您必须注册并登录到Croatia Times。",
  "static_commenting_rule_1": "对其他用户和文章主题保持尊重和文明",
  "static_commenting_rule_2": "禁止仇恨言论、种族主义、性别歧视或任何形式的歧视",
  "static_commenting_rule_3": "禁止垃圾邮件、广告或促销内容",
  "static_commenting_rule_4": "禁止错误信息或传播未经验证的声明",
  "static_commenting_rule_5": "禁止人身攻击或骚扰",
  "static_commenting_rule_6": "保持话题相关并贡献于对话",
  "static_commenting_rule_7": "禁止发布第三方的个人或机密信息",
  "static_commenting_title": "评论规则",
  "static_commenting_violation": "违反这些规则的评论可能会无通知地被移除。重复违反者可能会被永久禁止。",
  "static_contact_email": "电子邮箱",
  "static_contact_message": "消息",
  "static_contact_message_placeholder": "您的消息...",
  "static_contact_name": "姓名",
  "static_contact_name_placeholder": "您的姓名",
  "static_contact_send": "发送消息",
  "static_contact_sending": "发送中...",
  "static_contact_sent_desc": "我们将在24小时内回复您。",
  "static_contact_sent_title": "消息已发送！",
  "static_contact_subject": "主题",
  "static_contact_subject_placeholder": "我们能帮您什么？",
  "static_contact_title": "联系我们",
  "static_cookies_advertising_text": "我们可能使用Google AdSense Cookies来提供相关广告。",
  "static_cookies_advertising_title": "广告Cookies",
  "static_cookies_analytics_text": "Google Analytics帮助我们了解访客如何使用我们的网站。尽可能数据会被匿名化。",
  "static_cookies_analytics_title": "分析Cookies",
  "static_cookies_managing_text": "您可以通过浏览器设置控制Cookies。禁用必要的Cookies可能会影响网站功能。",
  "static_cookies_managing_title": "管理Cookies",
  "static_cookies_necessary_text": "这些是网站运行所需的（登录会话、主题偏好）。它们无法被禁用。",
  "static_cookies_necessary_title": "必要的Cookies",
  "static_cookies_title": "Cookie政策",
  "static_cookies_types_title": "我们使用的Cookies类型",
  "static_cookies_what_text": "Cookies是在您访问网站时放置在您设备上的小型文本文件。它们帮助网站记住您的偏好并了解您如何使用它。",
  "static_cookies_what_title": "什么是Cookies",
  "static_imprint_ads_email": "电子邮箱（广告）：",
  "static_imprint_ai_notice": "部分内容使用AI技术生成。报告错误或不当内容请联系",
  "static_imprint_contact": "联系方式",
  "static_imprint_copyright": "版权",
  "static_imprint_copyright_text": "Croatia Times 发布的所有内容均受版权保护。Liber Nostra d.o.o. 保留本网站发布的文本、图像和多媒体内容的所有权利。关于内容转发规则的详细信息请参见",
  "static_imprint_ct_desc": "Croatia Times 新闻门户",
  "static_imprint_disclaimer": "免责声明",
  "static_imprint_disclaimer_text": "尽管我们尽力控制内容，但对外部链接概不负责。其运营者对其内容承担全部责任。",
  "static_imprint_editorial_email": "电子邮箱（编辑部）：",
  "static_imprint_emina_desc": "国际新闻社",
  "static_imprint_general_email": "电子邮箱（一般咨询）：",
  "static_imprint_last_updated": "最后更新：2026年2月",
  "static_imprint_or_via": "或通过我们的",
  "static_imprint_publisher": "出版者",
  "static_imprint_registered": "在克罗地亚共和国注册",
  "static_imprint_reposting_page": "转发规则页面",
  "static_imprint_responsible": "内容负责人",
  "static_imprint_responsible_text": "Croatia Times / Liber Nostra d.o.o. 编辑团队",
  "static_imprint_title": "版权声明",
  "static_imprint_websites": "网站",
  "static_privacy_controller": "数据控制者：Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "我们使用Cookies来实现功能和分析。详情请参阅我们的Cookie政策。",
  "static_privacy_cookies_title": "Cookies",
  "static_privacy_data_text": "我们收集您直接提供的数据（注册时提供的姓名、电子邮箱）、使用数据（访问的页面、阅读的文章）和技术数据（IP地址、浏览器类型）。",
  "static_privacy_data_title": "我们收集的数据",
  "static_privacy_last_updated": "最后更新：2026年1月",
  "static_privacy_lead": "Croatia Times 尊重您的隐私并致力于保护您的个人数据。",
  "static_privacy_retention_text": "只要您的账户活跃或出于法律需要，我们将保留您的数据。",
  "static_privacy_retention_title": "数据保留",
  "static_privacy_rights_text": "您有权访问、更正或删除您的个人数据。请联系我们",
  "static_privacy_rights_title": "您的权利",
  "static_privacy_title": "隐私政策",
  "static_privacy_usage_text": "我们使用您的数据来提供我们的新闻服务，个性化您的体验，发送新闻通讯（在您同意的情况下），以及改进我们的平台。",
  "static_privacy_usage_title": "我们如何使用您的数据",
  "static_reposting_copyright_text": "Croatia Times上发布的所有内容均受版权保护。Liber Nostra d.o.o.保留对此网站上发布的文本、图像和多媒体的所有权利。",
  "static_reposting_copyright_title": "版权",
  "static_reposting_permission_text": "如需转载内容的权限，请联系我们",
  "static_reposting_permission_title": "权限请求",
  "static_reposting_permitted_text": "您可以在社交媒体和其他平台上分享我们文章的链接。引用（最多2段）可以在清楚注明出处并链接回原文章的情况下使用。",
  "static_reposting_permitted_title": "允许的使用",
  "static_reposting_prohibited_text": "未经书面许可，禁止全文转载文章。未经许可不得复制图像。内容的自动抓取严格禁止。",
  "static_reposting_prohibited_title": "禁止的使用",
  "static_reposting_title": "转载规则",
  "static_submit_news_details": "故事详情",
  "static_submit_news_details_placeholder": "描述新闻...",
  "static_submit_news_file_limit_error": "文件超出限制",
  "static_submit_news_headline": "新闻标题",
  "static_submit_news_intro": "有新闻？在这里发送，我们的编辑团队将进行审核。",
  "static_submit_news_limit": "我们接受的照片和视频文件最大为",
  "static_submit_news_photos": "照片/视频（最多",
  "static_submit_news_send": "提交新闻",
  "static_submit_news_sending": "发送中...",
  "static_submit_news_source": "来源/参考（可选）",
  "static_submit_news_source_placeholder": "URL或参考",
  "static_submit_news_thanks": "感谢您的提交！我们的团队将很快进行审核。",
  "static_submit_news_title": "提交您的新闻",
  "static_submit_news_your_name": "您的姓名",
  "status": "状态",
  "stop": "停止",
  "submit": "提交",
  "submitNews": "提交新闻",
  "submit_bug_title": "提交错误报告",
  "submit_news": "提交新闻",
  "submit_news_title": "提交新闻",
  "subscribe": "订阅",
  "subscription": "订阅",
  "subscription_title": "订阅计划",
  "success": "成功",
  "support": "支持",
  "tablet": "平板电脑",
  "tags": "标签",
  "target_impressions": "目标曝光",
  "technology": "科技",
  "template": "模板",
  "templates": "模板",
  "terms": "条款",
  "thank_you": "谢谢",
  "this_month": "本月",
  "this_week": "本周",
  "this_year": "今年",
  "tip": "提示",
  "title": "标题",
  "to": "到",
  "today": "今天",
  "total": "总计",
  "translate_all": "全部翻译",
  "translation_status": "翻译状态",
  "translations": "翻译",
  "travel": "旅行",
  "trending": "热门",
  "try_again": "重试",
  "twitter": "Twitter",
  "two_factor_auth": "双重认证",
  "type": "类型",
  "ugc_submit": "提交内容",
  "ugc_title": "公民新闻门户",
  "unique_clicks": "独特点击数",
  "unique_opens": "独特开启数",
  "unknown": "未知",
  "unpublish": "取消发布",
  "unread": "未读",
  "update": "更新",
  "updated_successfully": "更新成功",
  "upgrade": "升级",
  "upload": "上传",
  "users": "用户",
  "vehicles": "车辆",
  "verification_code_sent": "验证码已发送到您的电子邮件！",
  "version": "版本",
  "vibeposao": "Times Posao",
  "view": "查看",
  "view_all": "查看全部",
  "views": "浏览",
  "warning": "警告",
  "welcome": "欢迎",
  "wish_roles": "期望职位",
  "working_hours_saved": "工作时间已保存！",
  "world": "国际",
  "write_new_article": "撰写新文章",
  "yes": "是",
  "yesterday": "昨天",
  "your_bookings": "您的预订",
  "youtube": "YouTube"
}
